import React from "react";
import styles from "./.FilterBoxComponents.module.css";
import emailFilterStyles from "./ContactEmailFilter.module.css";

const EmailFilter = ({ 
  emailValidationStati, setEmailValidationStati, 
  emailProviders, setEmailProviders 
}) => {

  // EMAIL VALIDATION OPTIONS
  const emailValidationOptionsList = ["Any Status","Valid", "Catch All", "Invalid"];
  const handleEmailOptionsChange = (event) => {
    const { value, checked } = event.target;
    setEmailValidationStati((prevValues) =>
      checked
        ? prevValues.includes(value)
          ? prevValues
          : [...prevValues, value]
        : prevValues.filter((item) => item !== value)
    );
  };

  // EMAIL PROVIDER OPTIONS
  // const emailProviderOptionsList = [
  //   "Google",
  //   "Outlook",
  //   "Mimecast",
  //   "Proofpoint",
  //   "Other",
  // ];
  // const handleEmailProviderChange = (event) => {
  //   const { value, checked } = event.target;
  //   setEmailProviders((prevValues) =>
  //     checked
  //       ? prevValues.includes(value)
  //         ? prevValues
  //         : [...prevValues, value]
  //       : prevValues.filter((item) => item !== value)
  //   );
  // };

  return (
    <div className={styles.accordionContent}>
      {/* EMAIL VALIDATION STATUS */}
        <label>Email Status:</label>
        <div className={emailFilterStyles.emailCheckboxContainer}>
        {emailValidationOptionsList.map((option) => (
          <label key={option} className={emailFilterStyles.checkBoxRow}>
            <input
              type="checkbox"
              value={option}
              checked={emailValidationStati.includes(option)}
              onChange={handleEmailOptionsChange}
              className={emailFilterStyles.emailCheckbox}
            />
            <div>{option}</div>
          </label>
        ))}
          {/* <label className={emailFilterStyles.validationStatiSelectedText}>Selected: {emailValidationStati.join(", ") || "Any"}</label> */}
      </div>
      {/* <div className={emailFilterStyles.emailFilterDivider}></div> */}
      {/* EMAIL PROVIDER */}
      {/* <div className={emailFilterStyles.emailCheckboxContainer}>
        <label>Select Email Providers:</label>
          {emailProviderOptionsList.map((option) => (
            <label key={option} >
              <input
                type="checkbox"
                value={option}
                checked={emailProviders.includes(option)}
                onChange={handleEmailProviderChange}
                className={emailFilterStyles.emailCheckbox}
                // style={{ marginRight: "10px" }}
              />
              {option}
            </label>
          ))}
          <label className={emailFilterStyles.validationStatiSelectedText}>Selected: {emailProviders.join(", ") || "Any"}</label>
      </div> */}
    </div>
  );
};

export default EmailFilter;
